let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hgjyi")).then(() => parcelRequire('bFPu9'));